const data = {
  status: "success",
  items: [
    {
      id: 1,
      title: "Artesania de diriamba",
      price: 250,
      image: require("../images/artesania diria.jpg"),
      category: "artesanias",
      cantidad: 1,
    },
    {
      id: 2,
      title: "Ceramica San juan de oriente",
      price: 500,
      image: require("../images/ceramica san juan de oriente.jpg"),
      category: "Ceramica",
      cantidad: 1,
    },
    {
      id: 3,
      title: "Cortinas de nandasmo",
      price: 875,
      image: require("../images/cortinas nandasmo.jpg"),
      category: "Cortinas",
      cantidad: 1,
    },
    {
      id: 4,
      title: "Bolsos tejido a mano",
      price: 150,
      image: require("../images/bolsos.jpg"),
      category: "Bolsos",
      cantidad: 1,
    },
    {
      id: 5,
      title: "Bambú de Masaya",
      price: 300,
      image: require("../images/bambu masaya2.jpeg"),
      category: "Bambú",
      cantidad: 1,
    },
    {
      id: 6,
      title: "Bambú de Masaya",
      price: 285,
      image: require("../images/bambu masaya1.jpeg"),
      category: "Bambú",
      cantidad: 1,
    },
    {
      id: 7,
      title: "Joyeria de masaya",
      price: 360,
      image: require("../images/jolleria castillo Masaya1.jpeg"),
      category: "joyeria",
      cantidad: 1,
    },
    {
      id: 8,
      title: "Joyeria de masaya",
      price: 335,
      image: require("../images/jolleria castillo Masaya2.jpeg"),
      category: "joyeria",
      cantidad: 1,
    },
    {
      id: 9,
      title: "Muñecas de barro",
      price: 799,
      image: require("../images/muñecas de barro masaya.jpg"),
      category: "muñecas",
      cantidad: 1,
    },
    {
      id: 10,
      title: "Plantas de catarina",
      price: 100,
      image: require("../images/plantas catarina.jpg"),
      category: "plantas",
      cantidad: 1,
    },
    {
      id: 11,
      title: "Lampara de mimbre y bambú",
      price: 1200,
      image: require("../images/lamparas de mimbre y bambu.jpg"),
      category: "lampara",
      cantidad: 1,
    },
    {
      id: 12,
      title: "Hamacas de catarina",
      price: 1400,
      image: require("../images/amacas de catarina.jpg"),
      category: "hamacas",
      cantidad: 1,
    },
    {
      id: 13,
      title: "Artesania de catarina",
      price: 700,
      image: require("../images/artesanias de san juan de oriente.png"),
      category: "artesanias",
      cantidad: 1,
    },
    {
      id: 14,
      title: "Muñecas de barro",
      price: 900,
      image: require("../images/muñecas de barro masaya2.jpg"),
      category: "muñecas",
      cantidad: 1,
    },
    {
      id: 15,
      title: "Escultuas de nandasmo",
      price: 1100,
      image: require("../images/esculturas nandasmo1.jpg"),
      category: "escultura",
      cantidad: 1,
    },
  ],
};

export default data;
